
import React from 'react';
import { Link } from 'react-router-dom';
import DefaultData from '../../CompanyData/DefaultData'; // Adjust path if needed

const WebsiteTabs = (props) => {
  const baseTabStyle = { border: 'none', fontWeight: '500', padding: '0.75rem 1.5rem', borderRadius: '0.375rem 0.375rem 0 0' };
  const inactiveTabStyle = { ...baseTabStyle, backgroundColor: 'transparent', color: DefaultData.THEMECOLOR3, opacity: 2 };
  const activeTabStyle = { ...baseTabStyle, backgroundColor: DefaultData.THEMECOLOR2, color: DefaultData.THEMECOLOR3 };
  const getStyle = (pageName) => (props.pageName === pageName ? activeTabStyle : inactiveTabStyle);

  return (
    <div style={{ backgroundColor: DefaultData.THEMECOLOR5, padding: '0 1rem', borderBottom: `1px solid ${DefaultData.THEMECOLOR2}` }}>
      <ul className="nav nav-tabs" style={{ borderBottom: 'none' }}>
          <li className="nav-item" role="presentation">
              <Link to={"/agent-website-showcase"} className="nav-link" style={getStyle("AGENTWEBSITESHOWCASE")}>WEBSITE TEMPLATES</Link>
          </li>
          {/* <li className="nav-item" role="presentation">
              <Link to={"/website/edit"} className="nav-link" style={getStyle("WEBSITEEDITOR")}>LANDING PAGE</Link>
          </li> */}
      </ul>
    </div>
  );
};

export default WebsiteTabs;